<template>
  <div>
    <NavBar
      :narBarTitle="$t('绑定企业')"
      :msg="$t('上海新柏石智能科技股份有限公司')"
      :showLogo="true"
    />
    <van-form @submit="onBind" class="bindComForm">
      <van-field
        v-model="username"
        clearable
        name="name"
        :placeholder="$t('请输入您的姓名')"
      />

      <div class="bindComBox">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :disabled="!nameTest"
          class="bind-btn"
          :style="{ background: nameTest ? '#009BFF' : '#DDDDDD' }"
          >{{ $t('申请加入') }}</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import { bindCompany } from '@/services/api'
import Vue from 'vue'
import { Form, Field, Button, Toast } from 'vant'
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)
export default {
  name: 'BindCompany',
  components: {
    NavBar,
  },
  data() {
    return {
      user: {},
      mobile: '',
      username: '',
      companyCode: '',
    }
  },
  methods: {
    async onBind(v) {
      try {
        const res = await bindCompany({
          companyCode: this.companyCode.code,
          mobile: this.mobile,
          ...v,
        })
        this.user.name = res
        localStorage.setItem('user', JSON.stringify(this.user))
        this.$router.push('meeting')
      } catch (error) {
        console.log(error)
      }
    },
  },
  computed: {
    nameTest() {
      return this.username.length > 0
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.mobile = this.user.mobile
    this.companyCode = JSON.parse(localStorage.getItem('companyCode'))
  },
}
</script>
<style lang="less" scoped>
.bindComForm {
  margin: 33px 8px 0px;

  .form-spacing {
    margin-top: 12px;
  }

  .bindComBox {
    width: 280px;
    height: 44px;
    margin: 104px 40px 0px;
    .bind-btn {
      border: none;
      font-size: 16px;
    }
  }
}
</style>
